import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Users {
    createUser(data) {
        return BaseService.post(`${APIPath.users}/create`, data, this.isSecure)
    }

    createAdmin(data) {
        return BaseService.post(`${APIPath.users}/create-admin`, data, this.isSecure)
    }

    getUsersList(obj) {
        const params = CommonUtility.objectToParams(obj)
        return BaseService.get(`${APIPath.users}?${params}`, this.isSecure)
    }

    getUserById(id) {
        return BaseService.get(`${APIPath.users}/${id}`, this.isSecure)
    }

    block(id, block) {
        return BaseService.patch(`${APIPath.blockUser}/${id}?status=${block}`)
    }

    updateUserById(data, id) {
        return BaseService.patch(`${APIPath.users}/${id}`, data, this.isSecure)
    }

    deleteUser(id,status) {
        return BaseService.patch(`${APIPath.users}/${id}?status=${status}`, this.isSecure)
    }
}

const UsersService = new Users()
Object.freeze(UsersService)
export { UsersService }
